import { Sanity$Badge } from '@otovo/shared/types/sanityTypes';
import StarIcon from './star-icon.svg';

type Props = {
  badge: Sanity$Badge;
};

const getIcon = (icon: Sanity$Badge['icon']) => {
  if (!icon) return null;
  if (icon === 'star') return <StarIcon />;
  return null;
};

const Badge = ({ badge }: Props) => {
  return (
    <div className="mb-3 inline-flex w-fit items-center gap-1 rounded-lg bg-peach fill-heading px-2 py-1 whitespace-nowrap">
      {badge.icon && (
        <div className="flex size-4 items-center justify-center rounded-full bg-blue-100 text-center text-white">
          {getIcon(badge.icon)}
        </div>
      )}
      <span className="inline-block text-xs font-semibold text-grey-90 uppercase">
        {badge.text}
      </span>
    </div>
  );
};

export default Badge;
